module.exports = __webpack_public_path__ + "static/media/special-thanks.1dd9f4af.md";